import { defineStore } from 'pinia';

export const useUserStore = defineStore('user', {
  state: () => ({
    // usar sessionStorage para que la sesión se cierre al cerrar el navegador
    name: sessionStorage.getItem('user_name') || '',
    role: Number(sessionStorage.getItem('user_role')) || null,
    token: sessionStorage.getItem('auth_token') || '',
  }),
  actions: {
    setUser({ name, role, token }) {
      this.name = name;
      this.role = role;
      this.token = token;
      sessionStorage.setItem('user_name', name);
      sessionStorage.setItem('user_role', role);
      sessionStorage.setItem('auth_token', token);
    },
    clearUser() {
      this.name = '';
      this.role = null;
      this.token = '';
      sessionStorage.removeItem('user_name');
      sessionStorage.removeItem('user_role');
      sessionStorage.removeItem('auth_token');
    }
  }
});